export default function productInformationTabs() {
	const navItems = document.querySelectorAll(
		'li.product-information-tabs__nav-item'
	);
	const contentItems = document.querySelectorAll(
		'li.product-information-tabs__content-item'
	);

	function setActiveTab(index) {
		navItems.forEach((item) =>
			item.classList.remove('product-information-tabs__nav-item--active')
		);
		contentItems.forEach((item) =>
			item.classList.remove(
				'product-information-tabs__content-item--active'
			)
		);

		navItems[index].classList.add(
			'product-information-tabs__nav-item--active'
		);
		contentItems[index].classList.add(
			'product-information-tabs__content-item--active'
		);
	}

	navItems.forEach((navItem, index) => {
		navItem.addEventListener('click', () => {
			setActiveTab(index);
		});
	});

	const preset = new URL(location.href).searchParams.get('tab');
	if (preset) {
		const presetNavItem = document.querySelector(
			`li.product-information-tabs__nav-item[data-tab="${preset}"]`
		);
		const presetContentItem = document.querySelector(
			`li.product-information-tabs__content-item[data-tab="${preset}"]`
		);

		if (presetNavItem && presetContentItem) {
			setActiveTab([...navItems].indexOf(presetNavItem));
		}
	}
}
